<template>
	<div class="echarts">
		<div :id=id v-if="from=='hotTopic'"></div>
		<div id="echarts" style="width: 100%; height: 300px" v-else></div>
	</div>
</template>

<script>
	export default {
		name: 'echarts',
		props: ['data', 'date', 'title','from','id','dataInfo'],
		data() {
			return {
				myCharts: null,
				dateList: [],
				topiclick: [],
				clickList: [],
				publishList: [],
				publishUser: [],
			}
		},
	mounted() {
		if (!this.from) {
			this.myEcharts()
		}
		},
		watch: {
			// title改变时重新初始化echarts实例
			data(nval) {
				if (nval && !this.from ) {
					this.myEcharts()
				}
			},
			dataInfo: {
				handler(val) {
					for (let item of val) {
						this.dateList.push(item.recordDate);
						this.topiclick.push(item.topicClick);
						this.clickList.push(item.clickNum);
						this.publishList.push(item.publishNum);
						this.publishUser.push(item.publishUser);
					}
					this.$nextTick(function () {
						console.log(val)
						this.hotTopicChart()
					})
				},
				deep:true,
			}
		},
		methods: {
			myEcharts() {
				// 创建前判断echarts实例是否已存在
				if (this.myChart != null && this.myChart != '' && this.myChart != undefined) {
					this.myChart.dispose() // 已存在则先销毁
				}
				this.myChart = this.$echarts.init(document.getElementById('echarts'))
				let options = {
					title: {
						text: this.title + '折线图',
						left: '10%'
					},
					//跟随鼠标移动的框线
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'cross',
							label: {
								backgroundColor: '#6a7985'
							}
						}
					},
					// 图例
					legend: {
						data: '',
						show: true,
						right: '10%'
					},
					// x轴
					xAxis: {
						data: this.date
					},
					// y轴
					yAxis: {},
					// 线条
					series: [
						{
							name: this.title,
							data: this.data,
							type: 'line',
							smooth: true
						}
					]
				}
				// 配置写入实例
				
				this.myChart.setOption(options)
				// 窗口改变时echarts跟随改变尺寸
				window.onresize = () => {
					this.myChart.resize()
				}
			},
			// 显示话题折线图
			hotTopicChart() {
				let that = this;
				if (this.myChart != null && this.myChart != '' && this.myChart != undefined) {
					this.myChart.dispose() // 已存在则先销毁
				}
				this.myChart = this.$echarts.init(document.getElementById(that.id))
				console.log('ss',that.id)
				let option = {
					// 标题
					title: {
						text: that.title
					},
					// 鼠标移动显示数据
					 tooltip: {
						trigger: 'axis'
					},
					// 图例
					legend: {
						data: ['单日话题页进入量', '单日话题点击量', '单日发送消息总数', '单日发送消息人数']
					},
					grid: {
						left: '3%',
						right: '4%',
						bottom: '3%',
						top: '3%',
						containLabel: true
					},
					toolbox: {
						feature: {
						saveAsImage: {}
						}
					},
					xAxis: {
						type: 'category',
						boundaryGap: false,
						data: that.dateList,
					},
					yAxis: {
    					type: 'value'
					},
					series: [
						{
							name: '单日话题页进入量',
							type: 'line',
							stack: 'Total',
							data: that.topiclick
						},
						{
							name: '单日话题点击量',
							type: 'line',
							stack: 'Total',
							data: that.clickList
						},
						{
							name: '单日发送消息总数',
							type: 'line',
							stack: 'Total',
							data: that.topiclick
						},
						{
							name: '单日话题页进入量',
							type: 'line',
							stack: 'Total',
							data: that.publishList
						},
						{
							name: '单日发送消息人数',
							type: 'line',
							stack: 'Total',
							data: that.publishUser
						},
					]
				}
				// 配置写入实例
				this.myChart.setOption(option)
				// 窗口改变时echarts跟随改变尺寸
				window.onresize = () => {
					this.myChart.resize()
				}
			}
		}
	}
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/echarts_sec.vue